import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetResolvedOnlineUsers } from '../selectors/users'
import { makeGetCurrentTeam } from '../selectors/teams'

import AvatarBase from './avatar-base';

class UsersTyping extends PureComponent {
    get text() {
        let users = this.props.usersTyping.map(user => user.name);

        if (!users.length) {
            return null;
        }

        if (users.length === 1) {
            return `${users[0]} is typing…`;
        } else if (users.length < 4) {
            return `${users.slice(0, users.length - 1).join(', ')} and ${users.pop()} are typing…`;
        }

        return `${users.length} people are typing…`;
    }

    render() {
        if (!this.props.usersTyping.length) {
            return null;
        }

        return (
            <div className="editor-users-typing">
                <div className="faces">
                    {
                        this.props.usersTyping.length < 4 ? (
                            this.props.usersTyping.map(user => <AvatarBase
                                key={user.id}
                                image={user.avatar}
                                timezone={user.tz}
                                email={user.email}
                                text={user.initials}
                                size="xxxsmall"
                            />)
                        ) : (
                            <i className="icon material-icons">people</i>
                        )
                    }
                </div>

                <div className="text">
                    {this.text}
                </div>
            </div>
        )
    }
}

const makeMapStateToProps = () => {
    const getResolvedOnlineUsers = makeGetResolvedOnlineUsers();
    const getCurrentTeam = makeGetCurrentTeam();

    return ({ userActions, users, teams }, ownProps) => {
        const team = getCurrentTeam(teams);
        const usersTyping = userActions.typing[ownProps.discussionId] || [];

        return {
            usersTyping: team ? getResolvedOnlineUsers(usersTyping, users, team.url) : []
        }
    }
}

export default connect(makeMapStateToProps)(UsersTyping);
